/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdateComplianceStandardRequest extends models.ComplianceStandardBase {
    getFixupPrototypeFunction() { return UpdateComplianceStandardRequest.fixupPrototype; }

    static newInstance(model: Partial<UpdateComplianceStandardRequest>): UpdateComplianceStandardRequest {
        let obj = Object.assign(new UpdateComplianceStandardRequest(), model);
        UpdateComplianceStandardRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdateComplianceStandardRequest>): UpdateComplianceStandardRequest {
        if (!model) return null;
        return UpdateComplianceStandardRequest.newInstance(<UpdateComplianceStandardRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdateComplianceStandardRequest) {
        if (!obj) return;

        models.UpdateComplianceStandardRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdateComplianceStandardRequest): boolean {
        if (models.ComplianceStandardBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UpdateComplianceStandardRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
